module.exports = __webpack_public_path__ + "media/barometer/thumbnail-baba72a5.jpg";